import { api } from "./api";
import { orderPaymentEndPoints } from "../constants/endpoints";

export const updateOrderPaymentApi = async (payload: any, id: string) => {
  try {
    const endpointUrl = `${orderPaymentEndPoints.updateOrderPayment}/${id}`;
    return await api.put(endpointUrl, payload);
  } catch (error: any) {
    throw Error(error);
  }
};
